const swiperStyles = async () =>
  Promise.all([
    await import('swiper/swiper-bundle.min.css'),
    await import('swiper/swiper.min.css'),
  ]);

export default swiperStyles;
